import React from 'react'

import type { DnsRecord } from '@fourthwall/services/dist/DnsApiClient'

import { DnsRecordCodeCell } from '../DnsRecordCodeCell/DnsRecordCodeCell'
import * as S from './DnsRecordValueCell.styled'

export type DnsRecordValueCellProps = {
  record: DnsRecord
}

export const DnsRecordValueCell = ({ record }: DnsRecordValueCellProps) => (
  <>
    <DnsRecordCodeCell value={record.value || ''} recordAlias={record.alias} />
    {record.priority && <S.Priority>(Priority: {record.priority})</S.Priority>}
  </>
)
